import React from 'react';
import { Link } from 'react-router-dom';

const CourseRow = ({ course }) => {
    const {banner, title, heading, rating, review, lession, hours, host, fees, _id } = course

    return (
        <Link to={`/coursedetails/${_id}`}> <div className='p-3 rounded-3xl bg-white shadow-xl group  cursor-pointer w-full'>
            <div className='w-full h-44  md:h-56 rounded relative overflow-hidden bg-no-repeat bg-cover'>
                <img
                src={banner}
                    alt=""
                    className='w-full h-44 md:h-56 rounded group-hover:scale-110 transition duration-300 ease-in-out rounded-3xl' />
            </div>

            <div className='px-3 py-2 relative'>
                <img
                    src={host}
                    alt=""
                    className='border-4 border-white h-16 w-16 rounded-full absolute -top-7 right-5'
                />
                <h3 className='text-gray-500 mb-3 text-sm'>{title}</h3>
                <h3 className=' md:text-lg font-semibold mb-3 text-gray-700'>{heading}</h3>

                <div className='flex md:items-center flex-col md:flex-row gap-3'>
                    <div className='flex items-center gap-2 text-regal-orange'>
                        <i class="fa-solid fa-star"></i>
                        <i class="fa-solid fa-star"></i>
                        <i class="fa-solid fa-star-half-stroke"></i>
                        <i class="fa-regular fa-star"></i>
                        <i class="fa-regular fa-star"></i>
                    </div>
                    <h3 className='text-sm text-gray-500'>{review} ({rating}+ reviews)</h3>
                </div>
                <div className='flex items-center justify-between mt-5'>
                    <div className='flex items-center gap-5 text-gray-500'>
                        <h3 className='text-xs md:text-sm'><i class="fa-solid fa-computer "></i> {lession} lessons</h3>
                        <h3 className='text-xs md:text-sm'><i class="fa-regular fa-clock"></i> daily {hours} hours</h3>
                    </div>
                    <h3 className='md:text-xl font-semibold'>${fees}.99</h3>
                </div>
                {/* <div className='w-full mt-3 rounded-md bg-blue-900 py-2 flex items-center justify-center font-semibold text-white'>
                    See Details
                </div> */}
            </div>

        </div></Link>
    );
};

export default CourseRow;